import { MdAddCircle } from 'react-icons/md';
import { withInjectedProps } from '../InjectedPropsContext';
import './PlaceholderButton.scss';

interface IPlaceholderButtonBaseProps {
  onClick?: () => void;
  disabled?: boolean;
}

const PlaceholderButtonBase: React.FC<React.PropsWithChildren<IPlaceholderButtonBaseProps>> = ({
  children = undefined,
  onClick,
  disabled = undefined,
}) => (
  <button className="PlaceholderButton" onClick={onClick} disabled={disabled}>
    <MdAddCircle size="2em" />
    <span>{children}</span>
  </button>
);

const PlaceholderButton = withInjectedProps(PlaceholderButtonBase);

export { PlaceholderButton };
export default PlaceholderButton;
